import { render, staticRenderFns } from "./SpermMorphology.vue?vue&type=template&id=4dbe37ec&scoped=true&"
import script from "./SpermMorphology.vue?vue&type=script&lang=js&"
export * from "./SpermMorphology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe37ec",
  null
  
)

export default component.exports